import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=68ccb82c&scoped=true&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"
import style0 from "./upload.vue?vue&type=style&index=0&id=68ccb82c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ccb82c",
  null
  
)

component.options.__file = "src/demo/packageDemo/upload.vue"
export default component.exports